(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruqy-know-your-stone"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-ruqy-kys-carousel]');

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-ruqy-kys-track]');
      const dots = carousel.querySelectorAll('[data-ruqy-kys-dot]');
      const prevBtn = carousel.querySelector('[data-ruqy-kys-prev]');
      const nextBtn = carousel.querySelector('[data-ruqy-kys-next]');

      if (!track || !dots.length) return;

      const getActiveIndex = () => {
        const slides = Array.from(track.children);
        const scrollCenter = track.scrollLeft + track.clientWidth / 2;

        let activeIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(scrollCenter - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      };

      const setActiveDot = (index) => {
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      };

      const updateControls = () => {
        const activeIndex = getActiveIndex();
        const slideCount = track.children.length;

        setActiveDot(activeIndex);

        if (prevBtn) prevBtn.disabled = activeIndex === 0;
        if (nextBtn) nextBtn.disabled = activeIndex >= slideCount - 1;
      };

      const scrollToIndex = (index) => {
        const slide = track.children[index];

        if (!slide) return;

        track.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth',
        });
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          scrollToIndex(Number(dot.dataset.ruqyKysDot));
        });
      });

      prevBtn?.addEventListener('click', () => {
        scrollToIndex(getActiveIndex() - 1);
      });

      nextBtn?.addEventListener('click', () => {
        scrollToIndex(getActiveIndex() + 1);
      });

      track.addEventListener('scroll', updateControls, { passive: true });
      updateControls();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
